import { render, staticRenderFns } from "./TheProfileFieldSelect.vue?vue&type=template&id=56dd8d54&"
import script from "./TheProfileFieldSelect.vue?vue&type=script&lang=js&"
export * from "./TheProfileFieldSelect.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileFieldSelect.vue?vue&type=style&index=0&id=56dd8d54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports